import { UPDATE_LOGIN_SESSION, UPDATE_USER_LOGGING_IN,
    UPDATE_LOGIN_ERROR} from '../actions';

const initialState = {
    isLoginError: false,
    isLoggingIn: false,
    isLoggedIn: false,
    loginTokenType: null
};

export const sessionReducer = (state = initialState, action) => {
    switch(action.type) {
        case UPDATE_LOGIN_SESSION:
            return Object.assign({}, state, {
                isLoggedIn: action.payload.isLoggedIn,
                loginTokenType: action.payload.loginTokenType,
                isLoggingIn: false,
                isLoginError: false
            });
        case UPDATE_USER_LOGGING_IN:
            return Object.assign({}, state, {
                isLoggingIn: action.payload.isLoggingIn,
                isLoginError: false
            });

        case UPDATE_LOGIN_ERROR:
            return Object.assign({}, state, {
                isLoginError: action.payload.isLoginError,
                isLoggingIn: false
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/session_reducer.js